import {Injectable} from '@angular/core';
import {ApiClientHelper} from '../helpers/api-client.helper';
import {Observable} from 'rxjs';
import {AppConfig} from '../../shared/config/app-config';
import { StringHelper } from '../helpers/strings.helper';

interface ReferralCampaign {
	id: string;
	name: string;
	startDate: number;
	endDate: number;
	earnings: number;
	status: string;
	totalReferees: number;
}

export interface ReferralsDashboardData {
	referralCode: string;
	referralLink: string;
	balance: number;
	campaigns: ReferralCampaign[];
	minimumCashoutAmount: number;
}

export interface Cashout {
	accountName: string,
	accountNumber: string,
	amount: number;
	transactionReference: string;
	creationDate: number;
	status: 'PENDING' | 'COMPLETED' | 'FAILED';
}

@Injectable({
	providedIn: 'root',
})
export class ReferralsService {

	dashboardData: ReferralsDashboardData;

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
	) {
	}

	getPromoterDashboard(): Observable<any> {
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/loyalties/promoter/dashboard`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	getCampaigns(params): Observable<any> {
		const queryParams = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/loyalties/promoter/campaigns?${queryParams}`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	getCampaignDetails(id: string): Observable<any> {
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/loyalties/campaign/${id}`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	getCampaignReferrals(id: string, params): Observable<any> {
		const queryParams = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/loyalties/campaign/${id}/referrals?${queryParams}`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	getCampaignEarnings(id: string, params): Observable<any> {
		const queryParams = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/loyalties/campaign/${id}/earnings?${queryParams}`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	getPastCashouts(params): Observable<any> {
		const queryParams = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_REFERRALS_CASHOUT_SERVICE}/api/v1/referral/transactions?${queryParams}`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}

	postCashout(request): Observable<any> {
		const url = `${this.config.MONIEPOINT_REFERRALS_CASHOUT_SERVICE}/api/v1/referral/cashout`;
		return this.apiClientHelper.postForObservable(url, request, true, false, false);
	}

	getCashoutStatus(params): Promise<any> {
		const queryParams = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_REFERRALS_CASHOUT_SERVICE}/api/v1/referral/transaction?${queryParams}`;
		return this.apiClientHelper.getForPromise(url, true, false, false, {}, {}, false);
	}

	getReferralAccountBalance(): Observable<any> {
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/referral/account/balance`;
		return this.apiClientHelper.getForObservable(url, true, false);
	}
}
